import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';
import { colorGrid } from 's2s-themes';
import Button from 's2s-button';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { track } from 's2s-app-service';

const UpdateContainer = styled.div`
  background-color: ${colorGrid.gray0};
  border-radius: 2px;
  width: 100vw;
  height: 100vh;
`;

const UpdateHeader = styled.div`
  background-color: ${colorGrid.brand6};
  color: ${colorGrid.gray0};
  font-size: 18px;
  font-weight: 900;
  line-height: 25px;
  padding: 10px;
`;

const UpdateMsgArea = styled.p`
  background-color: ${colorGrid.gray1};
  border-bottom: 1px solid  ${colorGrid.gray3};
  padding: 10px 0px 19px;
  text-align: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-around;
`;

const PostponeButton = styled(Button)`
  width: 48.5%;
  border: 1px solid ${colorGrid.gray3};
`;

const UpdateButton = styled(Button)`
  width: 48.5%;
  border: 1px solid ${colorGrid.gray3};
`;



const Update = (props) => {

  const autoUpdateCountDownInitialValue = 30;

  const [autoUpdateCountDown, setCountDown] = useState(autoUpdateCountDownInitialValue);

  const [postpone, setPostpone] = useState(false);

  let timerId = null;

  useEffect(() => {
    // start the countdown timer
    callAutoUpdateCountDown();

    return () => {
      clearInterval(timerId);
    };
  }, [postpone]);
  
  const callAutoUpdateCountDown = () => {
    let timer = autoUpdateCountDownInitialValue;
    timerId = setInterval(() => {
      if (timer === 0) {
        clearInterval(timerId);
        // updateApp will only exist when running in Electron shell.  It is 'injected' by Electron.
        if(postpone === false){
          //eslint-disable-next-line
          updateApp(true);
        }
      } else {
        setCountDown(timer--);
      }
    }, 1000);
  };

  const handleUserUpdate = (userSelect) => { //userSelect True for update, false for postpone
    userSelect === false ? setPostpone(true) : setPostpone(false);
    if (typeof updateApp == 'function') {
      //eslint-disable-next-line
      updateApp(userSelect);
    } else if (typeof (window['updateApp']) == 'function') {
      window.updateApp(userSelect);
    } else {
      //LoggingService.getInstance().debug('^^^^^^^^^^^ where is updateApp', userSelect); // should only get this if running in a browser
    }
  };

  const postponeBtnOnClick = () => {
    track("postpone application update", "clicked");
    handleUserUpdate(false);
  };

  const updateBtnOnClick = () => {
    track("update application", "clicked");
    handleUserUpdate(true);
  };



  return (
    <UpdateContainer >
      <UpdateHeader
        className='header'
      >
        {getIntlText(props.intl, 'UPDATE-HEADER', 'Update Available')}
      </UpdateHeader>
      <UpdateMsgArea
        className='msgArea'
      >
        {getIntlText(props.intl, 'UPDATE-MSG', 'Would you like to restart the application now?')}
      </UpdateMsgArea>
      <ButtonGroup>
        <PostponeButton
          className="postpone"
          buttonLabel={getIntlText(props.intl, 'UPDATE-POSTPONE-BUTTON', 'Postpone (1 Min)')}
          ariaLabel={getIntlText(props.intl, 'ARIA-CANCEL-BTN', "Cancel button")}
          buttonType="outline"
          buttonShape="rectangle"
          cbClick={postponeBtnOnClick}
        />
        <UpdateButton
          className="update"
          buttonLabel={getIntlText(props.intl, 'UPDATE-UPDATE-BUTTON', 'Update') + ' (' + autoUpdateCountDown + ')'}
          ariaLabel={getIntlText(props.intl, 'ARIA-CANCEL-BTN', "Cancel button")}
          buttonType="primaryGreen"
          buttonShape="rectangle"
          cbClick={updateBtnOnClick}
        />
      </ButtonGroup>
    </UpdateContainer>
  );
};

Update.propTypes = {
  intl: PropTypes.object
};


export default injectIntl(Update);
